import type {SalesDynamicsSummary} from '@ozon-ai/ozon/contracts';
import {Card, CardDescription, CardHeader, CardTitle} from '@/components/ui/card.tsx';

const unitsFormat = new Intl.NumberFormat('ru-RU', {maximumFractionDigits: 2});

const ITEMS = [
	{key: 'sold', label: 'Продано'},
	{key: 'delivered', label: 'Доставлено'},
	{key: 'returned', label: 'Возвращено'},
] as const;

export function SalesDynamicsSummary({summary}: {summary: SalesDynamicsSummary}) {
	return (
		<div className="grid grid-cols-3 gap-3">
			{ITEMS.map((item) => (
				<Card key={item.key} size="sm">
					<CardHeader>
						<CardDescription>{item.label}</CardDescription>
						<CardTitle className="text-2xl tabular-nums">{unitsFormat.format(summary[item.key])}</CardTitle>
					</CardHeader>
				</Card>
			))}
		</div>
	);
}
